<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Income Proof</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">
                <form [formGroup]="model" (ngSubmit)="submit()" novalidate autocomplete="off">
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-12">

                            <!-- File Upload -->
                            <div class="form-group mt-4">
                                <label class="control-label">
                                    Income Proof Document (ITR)<span class="text-danger">*</span>
                                </label>
                                <input type="file" accept=".pdf,.jpg,.jpeg,.png" class="form-control mt-2"
                                    (change)="onFileSelected($event)" required />
                            </div>

                            <!-- Submit -->
                            <div class="text-center mt-4">
                                <button type="submit" class="btn btn-warning"
                                    [disabled]="!model.valid || !fileSelected">
                                    Submit
                                </button>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>